import React from "react";

export default function EditorialMotif({ className = "" }) {
  return (
    <svg
      className={`editorial-motif ${className}`}
      viewBox="0 0 440 230"
      role="presentation"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="croatoan-bone-a" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="0.44" stopColor="#d7d7d2" />
          <stop offset="0.7" stopColor="#fafaf8" />
          <stop offset="1" stopColor="#b8b8b1" />
        </linearGradient>
        <linearGradient id="croatoan-bone-b" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#c5c5bf" />
          <stop offset="0.4" stopColor="#ffffff" />
          <stop offset="0.66" stopColor="#deded9" />
          <stop offset="1" stopColor="#f7f7f4" />
        </linearGradient>
        <filter id="croatoan-bone-shadow" x="-30%" y="-50%" width="160%" height="200%">
          <feDropShadow dx="0" dy="8" stdDeviation="9" floodColor="#000000" floodOpacity="0.18" />
          <feDropShadow dx="0" dy="-2" stdDeviation="2" floodColor="#ffffff" floodOpacity="0.9" />
        </filter>
      </defs>

      <g fill="none" strokeLinecap="round" filter="url(#croatoan-bone-shadow)">
        <path d="M-28 47 C66 18 128 84 221 52 S358 22 468 57" stroke="url(#croatoan-bone-a)" strokeWidth="20" />
        <path d="M-16 91 C83 62 143 128 235 94 S360 67 458 101" stroke="url(#croatoan-bone-b)" strokeWidth="17" />
        <path d="M-25 137 C71 105 146 172 229 139 S356 108 470 148" stroke="url(#croatoan-bone-a)" strokeWidth="14" />
        <path d="M-8 182 C82 150 156 211 240 181 S364 153 452 192" stroke="url(#croatoan-bone-b)" strokeWidth="11" />
      </g>
    </svg>
  );
}
